
// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom"; 
// import { Tabs, Tab, Box, CircularProgress } from "@mui/material";
// import { getDecryptedAccessToken, getDecryptedUserType } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
// import EncounterData from "./EncounterData";
// import AssignForms from "./AssignForms";
// import CreateBill from "./BillingData/CreateBill";
// import ApiServices from "../../../Utils/ApiServices/ApiServices";
// import AppointmentExercises from "./AppointmentExercises/AppointmentExercises";
// import Exercises from "../../PatientComponents/Exercises/Exercises";
// import GeneratedBill from "./BillingData/GeneratedBill"; // Import GeneratedBill component

// const AppointmentDetailTabs = ({ appointmentData }) => {
//   const params = useParams();
//   const LoginUserType = getDecryptedUserType(); 
//   const accessToken = getDecryptedAccessToken();
//   const [tabIndex, setTabIndex] = useState(0); 
//   const [loading, setLoading] = useState(true); 
//   const [encounterData, setEncounterData] = useState(null);
//   const [billingData, setBillingData] = useState([]);
//   const [groupedBillData, setGroupedBillData] = useState({});

//   const pid = params.pid || appointmentData?.pc_pid;
//   const eid = params.eid || appointmentData?.pc_eid;

//   const apiUrl =
//     LoginUserType === "Patient"
//       ? `/apis/default/portal/getFormsPatient/${pid}/appointment/${eid}`
//       : `/apis/default/api/getFormsPatient/${pid}/appointment/${eid}`;

//   const billingApiUrl =
//     LoginUserType === "Patient"
//       ? `/apis/default/portal/patient/${pid}/billingwebGet/${eid}`
//       : `/apis/default/api/patient/${pid}/billingwebGet/${eid}`;

//   useEffect(() => {
//     if (!pid || !eid) return;

//     setLoading(true);

//     ApiServices.get(apiUrl, { Authorization: `Bearer ${accessToken}` })
//       .then((response) => {
//         setEncounterData(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching encounter data:", error);
//       })
//       .finally(() => {
//         setLoading(false);
//       });

//     ApiServices.get(billingApiUrl, { Authorization: `Bearer ${accessToken}` })
//       .then((response) => {
//         const sortedData = response.data.sort((a, b) => a.bill_id - b.bill_id);
//         setBillingData(sortedData);

//         const groupedData = sortedData.reduce((acc, item) => {
//           if (!acc[item.bill_id]) {
//             acc[item.bill_id] = [];
//           }
//           acc[item.bill_id].push(item);
//           return acc;
//         }, {});

//         setGroupedBillData(groupedData);
//       })
//       .catch((error) => {
//         console.error("Error fetching billing data:", error);
//       });
//   }, [pid, eid]);

//   return (
//     <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
//       <Tabs value={tabIndex} onChange={(e, newIndex) => setTabIndex(newIndex)}>
//         <Tab label="Encounter Data" />
//         {LoginUserType !== "Patient" && <Tab label="Assign Forms" />}
//         {LoginUserType !== "Patient" && <Tab label="Create Bill" />}
//         {LoginUserType === "Patient" ? <Tab label="Exercises" /> : <Tab label="Appointment Exercises" />}
        
//         {/* Dynamically add Billing Tabs */}
//         {Object.keys(groupedBillData).map((billId, index) => {
//           const isBilled = groupedBillData[billId][0]?.is_billed;
//           return (
//             <Tab
//               key={billId}
//               label={`Bill ${billId}`}
//               sx={{
//                 backgroundColor: isBilled === 1 ? "green" : "red",
//                 color: tabIndex === index + (LoginUserType === "Patient" ? 2 : 4) ? "white" : "black",
//                 "&.Mui-selected": { color: "white" },
//               }}
//             />
//           );
//         })}
//       </Tabs>

//       {loading ? (
//         <Box display="flex" justifyContent="center" alignItems="center" height="300px">
//           <CircularProgress color="primary" />
//         </Box>
//       ) : (
//         <Box sx={{ p: 2 }}>
//           {tabIndex === 0 && <EncounterData data={encounterData} appointmentData={appointmentData} />}
//           {LoginUserType !== "Patient" && tabIndex === 1 && <AssignForms data={encounterData} appointmentData={appointmentData} />}
//           {LoginUserType !== "Patient" && tabIndex === 2 && <CreateBill data={encounterData} appointmentData={appointmentData} />}
//           {tabIndex === (LoginUserType === "Patient" ? 1 : 3) && 
//             (LoginUserType === "Patient" ? <Exercises data={encounterData} appointmentData={appointmentData}/> : <AppointmentExercises data={encounterData} appointmentData={appointmentData}/>)}
          
//           {/* Render dynamic billing tabs */}
//           {Object.keys(groupedBillData).map((billId, index) => (
//             tabIndex === index + (LoginUserType === "Patient" ? 2 : 4) && (
//               <GeneratedBill key={billId} Billdata={groupedBillData[billId]} patientData={appointmentData} />
//             )
//           ))}
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default AppointmentDetailTabs;


import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Tabs, Tab, Box, CircularProgress } from "@mui/material";
import { getDecryptedAccessToken, getDecryptedUserType } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import EncounterData from "./EncounterData";
import AssignForms from "./AssignForms";
import CreateBill from "./BillingData/CreateBill";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import AppointmentExercises from "./AppointmentExercises/AppointmentExercises";
import Exercises from "../../PatientComponents/Exercises/Exercises";
import GeneratedBill from "./BillingData/GeneratedBill";
import WenoPrescription from "./WenoPrescription";

const AppointmentDetailTabs = ({ appointmentData }) => {
  const params = useParams();
  const LoginUserType = getDecryptedUserType();
  const accessToken = getDecryptedAccessToken();
  const [tabIndex, setTabIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [encounterData, setEncounterData] = useState(null);
  const [billingData, setBillingData] = useState([]);
  const [groupedBillData, setGroupedBillData] = useState({});

  const pid = params.pid || appointmentData?.pc_pid;
  const eid = params.eid || appointmentData?.pc_eid;

  const apiUrl =
    LoginUserType === "Patient"
      ? `/apis/default/portal/getFormsPatient/${pid}/appointment/${eid}`
      : `/apis/default/api/getFormsPatient/${pid}/appointment/${eid}`;

  const billingApiUrl =
    LoginUserType === "Patient"
      ? `/apis/default/portal/patient/${pid}/billingwebGet/${eid}`
      : `/apis/default/api/patient/${pid}/billingwebGet/${eid}`;

  useEffect(() => {
    if (!pid || !eid) return;

    setLoading(true);

    ApiServices.get(apiUrl, { Authorization: `Bearer ${accessToken}` })
      .then((response) => {
        setEncounterData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching encounter data:", error);
      })
      .finally(() => {
        setLoading(false);
      });

    ApiServices.get(billingApiUrl, { Authorization: `Bearer ${accessToken}` })
      .then((response) => {
        const sortedData = response.data.sort((a, b) => a.bill_id - b.bill_id);
        setBillingData(sortedData);

        const groupedData = sortedData.reduce((acc, item) => {
          if (!acc[item.bill_id]) {
            acc[item.bill_id] = [];
          }
          acc[item.bill_id].push(item);
          return acc;
        }, {});

        setGroupedBillData(groupedData);
      })
      .catch((error) => {
        console.error("Error fetching billing data:", error);
      });
  }, [pid, eid]);

  // Calculate tab index offsets
  const baseTabsCount = LoginUserType === "Patient" ? 2 : 5; // Encounter, Assign Forms, Create Bill, Exercises, Prescription
  const billingTabStartIndex = baseTabsCount;

  return (
    <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
      <Tabs value={tabIndex} onChange={(e, newIndex) => setTabIndex(newIndex)}>
        <Tab label="Encounter Data" />
        {LoginUserType !== "Patient" && <Tab label="Assign Forms" />}
        {LoginUserType !== "Patient" && <Tab label="Create Bill" />}
        {LoginUserType === "Patient" ? (
          <Tab label="Exercises" />
        ) : (
          <Tab label="Appointment Exercises" />
        )}
        {LoginUserType !== "Patient" && <Tab label="Prescription" />}

        {/* Dynamically add Billing Tabs */}
        {Object.keys(groupedBillData).map((billId, index) => {
          const isBilled = groupedBillData[billId][0]?.is_billed;
          return (
            <Tab
              key={billId}
              label={`Bill ${billId}`}
              sx={{
                backgroundColor: isBilled === 1 ? "green" : "red",
                color: tabIndex === index + billingTabStartIndex ? "white" : "black",
                "&.Mui-selected": { color: "white" },
              }}
            />
          );
        })}
      </Tabs>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="300px">
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <Box sx={{ p: 2 }}>
          {tabIndex === 0 && (
            <EncounterData data={encounterData} appointmentData={appointmentData} />
          )}
          {LoginUserType !== "Patient" && tabIndex === 1 && (
            <AssignForms data={encounterData} appointmentData={appointmentData} />
          )}
          {LoginUserType !== "Patient" && tabIndex === 2 && (
            <CreateBill data={encounterData[0]} appointmentData={appointmentData} />
          )}
          {tabIndex === (LoginUserType === "Patient" ? 1 : 3) &&
            (LoginUserType === "Patient" ? (
              <Exercises data={encounterData} appointmentData={appointmentData} />
            ) : (
              <AppointmentExercises data={encounterData} appointmentData={appointmentData} />
            ))}
          {LoginUserType !== "Patient" && tabIndex === 4 && (
            <WenoPrescription data={encounterData} appointmentData={appointmentData} />
          )}

          {/* Render dynamic billing tabs */}
          {Object.keys(groupedBillData).map((billId, index) =>
            tabIndex === index + billingTabStartIndex ? (
              <GeneratedBill
                key={billId}
                Billdata={groupedBillData[billId]}
                patientData={appointmentData}
              />
            ) : null
          )}
        </Box>
      )}
    </Box>
  );
};

export default AppointmentDetailTabs;
